var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-primary",class:{'disabled':_vm.loading},attrs:{"disabled":_vm.loading},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.loading)?_c('div',{staticClass:"spinner-grow"}):_vm._e(),(!_vm.loading)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }